import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const USER_CATEGORY_KEY = 'USER_CATEGORY';
export const USER_GUIDE_DONE_KEY = 'USER_GUIDE_DONE';

// Configurable — change to highlight a different layer in the guide
export const GUIDE_HIGHLIGHT_FEATURE = 'MEDIAN_HOUSEHOLD_INCOME_TREND';

// Configurable — minimum zoom level to complete the zoom task
export const GUIDE_MIN_ZOOM = 7;

// Configurable — promo code shown after completing all guide tasks
export const GUIDE_PROMO_CODE = 'BESTLOCATION';

export const PROMO_CODE_DISMISSED_KEY = 'PROMO_CODE_DISMISSED';

@Injectable({ providedIn: 'root' })
export class UserGuideService {
  // Emits the featureConst key that should receive the purple highlight in the menu.
  // null = no highlight active.
  readonly highlightFeature$ = new BehaviorSubject<string | null>(null);
}
